import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";
import AppContextWrapper from "./context/appContextWrapper";
import App from "./App";

ReactDOM.render(
  <AppContextWrapper>
    <App />
  </AppContextWrapper>,
  document.getElementById("root")
);
